// extracted by mini-css-extract-plugin
export default {"container":"ReminderConfirmModal_container__UzE6X","warning-icon":"ReminderConfirmModal_warning-icon__IFhfk","title":"ReminderConfirmModal_title__J501v"};